import type { OrgTeams } from '@/types/github';

export const orgTeamsQueryKey = (org: string) => ['org-teams', org] as const;

export async function fetchOrgTeams(
  org: string | undefined,
  signal?: AbortSignal,
): Promise<OrgTeams | null> {
  if (!org) {
    return null;
  }

  const response = await fetch(`/api/github/orgs/${org}/teams`, {
    method: 'POST',
    signal,
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch org teams: ${response.statusText}`);
  }

  return response.json();
}
